module.exports = __webpack_public_path__ + "static/img/product_digitization.72f6f82.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/product_digitization.png
// module id = MQZC
// module chunks = 0